import { headers } from "../../../config/config";
import { MESSAGE } from "../../../constants/api/message";
import { ContactDetails } from "../../../types/contactUs.types";
import { request } from "../api";

const { post } = request;
const initialRoute = "contact-us";

export const sendContactUsEmail = async (_payload: ContactDetails): Promise<string> => {
	try {
		const endpoint = `${initialRoute}`;
		const token = localStorage.getItem("@jwt_member");
		const payload = JSON.stringify(_payload);
		const response = await post(endpoint, payload, {
			...headers,
			Authorization: `Bearer ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.post.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (err) {
		throw err;
	}
};
